import React, { useCallback, useMemo } from 'react';
import { Keyboard, StyleSheet, View } from 'react-native';
import Modal from 'utils/packages/Modal';
import Text from 'design-system/Text';
import { Spacer } from 'design-system';
import { isPremiumTier, Tier, } from 'features/premium/entities';
import { selectConnectionsLimit, selectShouldShowMicroModal, } from 'features/premium/selectors';
import { selectUserTier } from 'features/premium/selectors/tier';
import { selectActiveConnectionsWithoutManual, selectIsLoggedIn, } from 'reducers/selectors';
import { useAppSelector } from 'store/hooks';
import Amplitude from 'utils/amplitude';
import { RenderUnlockIcon } from 'features/premium/components/PremiumFeatureMicroModalContent';
import { benefits } from 'features/premium/benefits';
import useV3MicroModal from 'features/premium/hooks/useV3MicroModal';
import AccountConnectionsLimitModalContent from '../components/AccountConnectionsLimitModalContent';
const getCurrentLimit = (connectionsLimitMap, currentConnections, activeTier) => {
    const currentLimit = connectionsLimitMap[activeTier || Tier.free];
    if (currentLimit === null) {
        return null;
    }
    if (currentConnections < currentLimit) {
        return null;
    }
    return currentLimit;
};
const useConnectionsLimitModal = () => {
    const isLoggedIn = useAppSelector(selectIsLoggedIn);
    const connections = useAppSelector(selectActiveConnectionsWithoutManual);
    const connectionsLimit = useAppSelector(selectConnectionsLimit);
    const userTier = useAppSelector(selectUserTier);
    // Ab test
    const showMicroModal = useAppSelector(selectShouldShowMicroModal);
    const v3MicroModal = useV3MicroModal();
    const title = useMemo(() => {
        const titleString = 'Upgrade to add more';
        if (showMicroModal) {
            return (<View style={styles.container}>
          <Spacer h={40}/>
          <RenderUnlockIcon />
          <Spacer h={16}/>
          <Text Text-20 centered>
            Unlock Bank connections
          </Text>
        </View>);
        }
        return titleString;
    }, [showMicroModal]);
    const open = useCallback((onContinue) => {
        if (connectionsLimit && isLoggedIn) {
            const currentLimit = getCurrentLimit(connectionsLimit, connections.length, userTier);
            if (currentLimit !== null) {
                Keyboard.dismiss();
                Amplitude.logEvent('Connections Limit Modal Opened');
                if (showMicroModal === 'v3') {
                    v3MicroModal(isPremiumTier(benefits.connections.minTier)
                        ? benefits.connections.minTier
                        : undefined, 'connections');
                }
                else {
                    Modal.show(<AccountConnectionsLimitModalContent currentLimit={currentLimit}/>, {
                        title,
                    });
                }
                return;
            }
        }
        onContinue();
    }, [
        connectionsLimit,
        isLoggedIn,
        connections.length,
        userTier,
        showMicroModal,
        v3MicroModal,
        title,
    ]);
    return open;
};
const styles = StyleSheet.create({
    container: {
        justifyContent: 'center',
        alignItems: 'center',
    },
});
export default useConnectionsLimitModal;
